import { NumberInput } from "@mantine/core";

export const BaseNumberInput = NumberInput